import React, {Component} from 'react'
import Select from 'react-select'
import 'react-select/dist/react-select.css'
import LaddaButton, {SLIDE_UP} from '../LaddaButton'
import * as GymHelpers from '../../helpers/gymHelpers'
import * as UserHelpers from '../../helpers/userHelpers'
import StarRatingComponent from 'react-star-rating-component'
import _ from 'lodash'

class AddProblem extends Component {
  constructor(props) {
    super(props)
    let activeProblem = this.props.activeProblem
    let rating = activeProblem ? activeProblem.rating : 3
    if (rating === undefined) {
      rating = 3
    }
    this.state = {
      newProblemGrade: activeProblem
        ? activeProblem.grade
        : GymHelpers.grades[0],
      newProblemFeet: activeProblem ? activeProblem.feet : GymHelpers.feet[0],
      newProblemNotes: activeProblem ? activeProblem.notes : '',
      newProblemName: activeProblem ? activeProblem.name : '',
      newProblemId: activeProblem ? activeProblem.id : undefined,
      newProblemRating: rating,
      key: activeProblem ? activeProblem.key : undefined,
    }
    this.handleGradeChange = this.handleGradeChange.bind(this)
    this.handleSaveProblem = this.handleSaveProblem.bind(this)
    this.handleNameChange = this.handleNameChange.bind(this)
    this.handleFeetChange = this.handleFeetChange.bind(this)
    this.handleNotesChange = this.handleNotesChange.bind(this)
  }
  handleGradeChange(selectedOption) {
    this.setState({
      newProblemGrade: GymHelpers.grades[selectedOption.value],
    })
  }
  handleNotesChange(e) {
    this.setState({
      newProblemNotes: e.target.value,
    })
  }
  handleNameChange(e) {
    this.setState({
      newProblemName: e.target.value,
      newProblemId: e.target.value.toLowerCase(),
      errors: undefined,
    })
  }

  handleFeetChange = selectedOption => {
    this.setState({
      newProblemFeet: GymHelpers.feet[selectedOption.value],
    })
  }

  handleRatingChange = (nextValue, prevValue, name) => {
    this.setState({
      newProblemRating: nextValue,
    })
  }

  handleSaveProblem(e) {
    e.preventDefault()
    if (!this.state.newProblemName) {
      this.setState({
        errors: ['Please add a problem name'],
      })
      return
    }
    this.setState({
      isSavingProblem: true,
    })
    let currentUser = UserHelpers.getCurrentUser()
    let problemHolds = this.props.holds
      .map((hold, index) => {
        return Object.assign({}, hold, {index: index})
      })
      .filter(hold => hold.selected)
    let activeProblem = this.props.activeProblem
    let userName = activeProblem
      ? activeProblem.userName
      : currentUser && currentUser.displayName
    let userId = activeProblem
      ? activeProblem.userId
      : UserHelpers.getCurrentUserId()
    let firebaseProblem = {
      grade: this.state.newProblemGrade,
      name: this.state.newProblemName,
      id: this.state.newProblemId,
      holds: problemHolds,
      gymId: this.props.gymId,
      gymKey: this.props.gymKey,
      wallId: this.props.wallId,
      userId: userId,
      userName: userName,
      feet: this.state.newProblemFeet,
      notes: this.state.newProblemNotes,
      ascents: 0,
      timestamp: window.firebase.firestore.FieldValue.serverTimestamp(),
      rating: this.state.newProblemRating,
    }
    let addHoldPromise
    console.info('firebaseProblem:')
    console.info(firebaseProblem)
    _.each(firebaseProblem, (val, key) => {
      console.info(key + ': ' + val)
    })

    if (this.state.key) {
      // window.Raven.captureMessage('SAVING EXISTING PROBLEM', {
      //   level: 'info',
      //   extra: firebaseProblem,
      // })
      addHoldPromise = window.firebaseDb
        .collection('problems')
        .doc(this.state.key)
        .set(firebaseProblem)
    } else {
      // window.Raven.captureMessage('NEW PROBLEM', {
      //   level: 'info',
      //   extra: firebaseProblem,
      // })
      addHoldPromise = window.firebaseDb
        .collection('problems')
        .add(firebaseProblem)
    }
    addHoldPromise.then(() => {
      this.setState(
        {
          isSavingProblem: false,
        },
        () => {
          this.props.addProblemCallback && this.props.addProblemCallback()
        },
      )
    })
  }
  render() {
    let activeHoldIndex = this.props.activeHoldIndex
    return (
      <form style={{width: '100%'}}>
        {activeHoldIndex !== undefined && (
          <div className="full-width">
            <LaddaButton
              onClick={e => {
                e.preventDefault()
                this.props.addHoldMetadata(activeHoldIndex, {startHold: true})
              }}
              data-color="mint"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'half-width'}>
              set start hold
            </LaddaButton>
            <LaddaButton
              onClick={e => {
                e.preventDefault()
                this.props.addHoldMetadata(activeHoldIndex, {endHold: true})
              }}
              data-color="red"
              data-style={SLIDE_UP}
              data-spinner-color="#ddd"
              className={'half-width'}>
              set end hold
            </LaddaButton>
          </div>
        )}
        <label style={{paddingTop: '10px'}}>
          Select holds by clicking on the image above
        </label>
        <hr />
        <div className="form-group">
          <label>Problem name</label>
          <div className="input-wrapper">
            <input
              style={{display: 'block'}}
              placeholder="Problem Name"
              onChange={this.handleNameChange}
              value={this.state.newProblemName || ''}></input>
          </div>
        </div>
        <div className="form-group">
          <label>Grade</label>
          <Select
            name="new-problem-grade-dropdown"
            className="form-select"
            value={
              this.state.newProblemGrade &&
              this.state.newProblemGrade.numberGrade
            }
            onChange={this.handleGradeChange}
            clearable={false}
            placeholder="Select grade"
            options={GymHelpers.grades.map((grade, index) => {
              return {value: index, label: grade.vgrade}
            })}
            searchable={false}
            autosize={false}
            disabled={false}
          />
        </div>

        <div className="form-group">
          <label>Feet</label>
          <Select
            name="new-problem-feet-dropdown"
            value={
              (this.state.newProblemFeet && this.state.newProblemFeet.index) ||
              0
            }
            onChange={this.handleFeetChange}
            className="form-select"
            clearable={false}
            placeholder="Select feet"
            options={GymHelpers.feet.map((foot, index) => {
              return {value: foot.index, label: foot.text}
            })}
            searchable={false}
            autosize={false}
            disabled={false}
          />
        </div>
        <div className="form-group">
          <label>Rating</label>
          <StarRatingComponent
            name="boulder-rating"
            editing={true}
            starCount={5}
            emptyStarColor="#aaaaaa"
            value={this.state.newProblemRating}
            // onChange={this.state.handleRatingChange}
            onStarClick={this.handleRatingChange}
          />
        </div>
        <div className="form-group">
          <label>Notes</label>
          <div className="input-wrapper">
            <textarea
              onChange={this.handleNotesChange}
              placeholder="Notes..."
              rows="4"
              value={
                (this.state.newProblemNotes && this.state.newProblemNotes) || ''
              }
            />
          </div>
        </div>
        {this.state.errors && (
          <div className="form-group form-errors">
            {this.state.errors.map((e, index) => {
              return <div key={index}>{e}</div>
            })}
          </div>
        )}
        <LaddaButton
          loading={this.state.isSavingProblem}
          onClick={this.handleSaveProblem}
          data-color="mint"
          data-style={SLIDE_UP}
          data-spinner-color="#ddd"
          className="half-width">
          Save Problem
        </LaddaButton>
        <LaddaButton
          onClick={this.props.onCancel}
          data-style={SLIDE_UP}
          data-spinner-color="#ddd"
          className="half-width">
          Cancel
        </LaddaButton>
      </form>
    )
  }
}

export default AddProblem



// WEBPACK FOOTER //
// ./src/components/problems/AddProblem.jsx